import React, { useState } from 'react'
import { Waypoint } from 'react-waypoint'
import { EarthCoverReact } from 'components/earthCoverReact'
import StyleSheet from './scrollytellingCover.m.scss'
import AnimatedNumber from 'react-animated-number'

const darkMode =
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

export const ScrollyTellingCover = () => {
  const [stage, setStage] = useState({
    id: 0,
    direction: 'down'
  })

  const handleEnterWaypoint = (currentStageId, e) => {
    if (e.previousPosition === 'below') {
      console.log({
        id: currentStageId,
        direction: 'down'
      })

      setStage({
        id: currentStageId,
        direction: 'down'
      })
    }
  }

  const handleLeaveWaypoint = (currentStageId, e) => {
    if (e.previousPosition === 'inside') {
      if (stage.id === currentStageId) {
        console.log({
          id: currentStageId - 1,
          direction: 'up'
        })

        setStage({
          id: currentStageId - 1,
          direction: 'up'
        })
      }
    }
  }

  const date = {
    0: {
      text: 'Samedi 18 janvier 2020',
      dist: 711956
    },
    1: {
      text: 'Samedi 18 janvier 2020',
      dist: 711956
    },
    2: {
      text: 'Samedi 21 mars 2020',
      dist: 216980
    },
    3: {
      text: 'Samedi 19 avril 2020',
      dist: 19709
    },
    4: {
      text: 'Samedi 15 janvier 2022',
      dist: 543354
    }
  }

  return (
    <div
      className='ui vertical segment'
      style={{
        backgroundColor: darkMode ? '#121212' : '#ffffff',
        position: 'relative'
      }}
    >
      <div className={StyleSheet.earthContainer}>
        {stage.id > 0 && (
          <div className={StyleSheet.header}>
            <div className='ui text container'>
              {/* <div className={StyleSheet.title}>
                Vols au départ et à l'arrivée de l'aéroport de Genève
              </div>
              <div className={StyleSheet.titleDate}>{date[stage.id].text}</div> */}
              <div className={StyleSheet.title}>{date[stage.id].text}</div>
              <div className={StyleSheet.distanceLabel}>
                Distance totale parcourue:{' '}
                <b>
                  <AnimatedNumber
                    value={date[stage.id].dist}
                    formatValue={v =>
                      `${v.toLocaleString('fr-CH', {
                        minimumFractionDigits: 0
                      })}km`
                    }
                    duration={300}
                    stepPrecision={0}
                  />
                </b>
                <div className={StyleSheet.distanceBarContainer}>
                  <div className={StyleSheet.distanceBarTicks}>
                    <div
                      className={StyleSheet.distanceBarTickFirst}
                      style={{
                        left: '100%',
                        textAlign: 'right',
                        marginLeft: '-80px'
                      }}
                    >
                      janv. 19
                    </div>
                    {stage.id > 1 && (
                      <div
                        className={StyleSheet.distanceBarTick}
                        style={{ left: '30.48%' }}
                      >
                        mars 20
                      </div>
                    )}
                    {stage.id > 2 && (
                      <div
                        className={StyleSheet.distanceBarTick}
                        style={{ left: '2.8%' }}
                      >
                        avr. 21
                      </div>
                    )}
                    {stage.id > 3 && (
                      <div
                        className={StyleSheet.distanceBarTickFirst}
                        style={{
                          left: '76.3%',
                          textAlign: 'right',
                          marginLeft: '-80px'
                        }}
                      >
                        janv. 22
                      </div>
                    )}
                  </div>
                  <div
                    className={StyleSheet.distanceBar}
                    style={{
                      width:
                        (date[stage.id].dist /
                          Object.values(date).reduce((p, c) =>
                            p.dist > c.dist ? p : c
                          ).dist) *
                          100 +
                        '%'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <EarthCoverReact stage={stage.id} />
      </div>
      <Waypoint
        onEnter={e => {
          handleEnterWaypoint(1, e)
        }}
        onLeave={e => {
          handleLeaveWaypoint(1, e)
        }}
      >
        <div className={`ui ta text container ${StyleSheet.scrollContainer}`}>
          <div
            className='scroll-text'
            style={{ paddingTop: '0vh', paddingBottom: '100vh' }}
          >
            <div className={StyleSheet.scrollText}>
              <p>
                Chacune des ces{' '}
                <span className={StyleSheet.coloredSpan}>
                  lignes <i className={StyleSheet.legendLine} />
                </span>{' '}
                représente un vol au départ ou à l'arrivée de l'aéroport de
                Genève, toutes catégories confondues: vol de ligne, jet privé,
                transport de marchandises. On en compte 533 le{' '}
                <span className={StyleSheet.coloredSpan}>18 janvier 2020</span>,
                un chiffre habituel pour un samedi.
              </p>
            </div>
          </div>
        </div>
      </Waypoint>
      <Waypoint
        onEnter={e => {
          handleEnterWaypoint(2, e)
        }}
        onLeave={e => {
          handleLeaveWaypoint(2, e)
        }}
      >
        <div className={`ui ta text container ${StyleSheet.scrollContainer}`}>
          <div
            className='scroll-text'
            style={{ paddingTop: '0vh', paddingBottom: '100vh' }}
          >
            <div className={StyleSheet.scrollText}>
              <p>
                Le <span className={StyleSheet.coloredSpan}>21 mars 2020</span>{' '}
                est le premier samedi après l’annonce du confinement. Les
                contrôles sont rétablis aux frontières et l’entrée sur le sol
                helvétique est partiellement interdite. Le transit de
                marchandises reste possible. On compte 172 vols, trois fois
                moins que d’habitude.
              </p>
            </div>
          </div>
        </div>
      </Waypoint>
      <Waypoint
        onEnter={e => {
          handleEnterWaypoint(3, e)
        }}
        onLeave={e => {
          handleLeaveWaypoint(3, e)
        }}
      >
        <div className={`ui ta text container ${StyleSheet.scrollContainer}`}>
          <div
            className='scroll-text'
            style={{ paddingTop: '0vh', paddingBottom: '100vh' }}
          >
            <div className={StyleSheet.scrollText}>
              <p>
                Le <span className={StyleSheet.coloredSpan}>19 avril</span>,
                seuls 8 avions décollent de Genève et 8 y atterrissent. En deux
                ans de pandémie, c’est le pire samedi que connaît Genève
                Aéroport.
              </p>
            </div>
          </div>
        </div>
      </Waypoint>
      <Waypoint
        onEnter={e => {
          handleEnterWaypoint(4, e)
        }}
        onLeave={e => {
          handleLeaveWaypoint(4, e)
        }}
      >
        <div className={`ui ta text container ${StyleSheet.scrollContainer}`}>
          <div
            className='scroll-text'
            style={{ paddingTop: '0vh', paddingBottom: '100vh' }}
          >
            <div className={StyleSheet.scrollText}>
              <p>
                Deux ans plus tard, au{' '}
                <span className={StyleSheet.coloredSpan}>début de 2022</span>,
                le nombre de vols se redresse. On en compte 457 le samedi 12
                février, qui marque le début des vacances scolaires genevoises.
              </p>
            </div>
          </div>
        </div>
      </Waypoint>
    </div>
  )
}
